/**
 * Toggle class function to enable translate of the widget as well as rotation of the arrow icon.
 */
function toggleWidget() {
	const widget = document.querySelector( '.slide-out-widget__wrapper' );
	const widgetArrowIcon = document.querySelector( '.slide-out-widget__hint-arrow-icon' );

	widget.classList.toggle( 'open' );
	widgetArrowIcon.classList.toggle( 'rotate' );
}

const widgetTab = document.querySelector( '.slide-out-widget__hint__inner-wrapper' );
const closeButton = document.querySelector( '.slide-out-widget__close-btn' );

if ( widgetTab ) {
	widgetTab.addEventListener( 'click', toggleWidget );
}
if ( closeButton ) {
	closeButton.addEventListener( 'click', toggleWidget );
}

// bounce class that make the widget bounce into the viewport.
window.addEventListener( 'load', function() {
	const widget = document.querySelector( '.slide-out-widget__wrapper' );
	if ( widget ) {
		widget.classList.add( 'slide-out-widget__wrapper--bounce' );
	}
} );

